module.exports = __webpack_public_path__ + "static/media/gw.fbbdf5ef.jpg";